import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';
import { Td, Tr, Th, Table, TdImp, HorizontalContent } from './css';
import { Error } from '../../design/elements';

const Services = ({ products, onProductsChange, label, error = '' }) => {

  const onChange = (e, idx, type) => {
    e.preventDefault();
    onProductsChange(
      products.map((serviceItem, serviceIndex) => ({
        ...serviceItem,
        ...(serviceIndex === idx ? { [type]: +e.target.value } : {})
      }))
    );
  };

  return (
    <>
      <Table>
        <Th style={{ width: '40%' }}><Typography>{label}</Typography></Th>
        <Th><Typography>One-Time Pricing (per Qty)</Typography></Th>
        <Th><Typography>Recurring Price (per Qty)</Typography></Th>
        <Th><Typography>Quantity</Typography></Th>
        {products.map(
          ({ name, price, quantity, priceType, isMandatory }, idx) => {
            return (
              <Tr>
                <Td>
                  <Typography>{name} {isMandatory ? '*' : ''}</Typography>
                </Td>
                {priceType === 'recurring' ? (
                  <TdImp />
                ) : (
                  <Td>
                    <HorizontalContent>
                      $
                      <input
                        type="Number"
                        onWheel={e => e.target.blur()}
                        value={price}
                        defaultValue={price}
                        placeholder="One-Time Price"
                        className="frg-input-field color-light"
                        style={{ width: '100%' }}
                        onChange={e => onChange(e, idx, 'price')}
                      />
                    </HorizontalContent>
                  </Td>
                )}
                {priceType === 'oneTime' ? (
                  <TdImp />
                ) : (
                  <Td>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <HorizontalContent>
                        $
                        <input
                          type="Number"
                          onWheel={e => e.target.blur()}
                          value={price}
                          placeholder="Recurring Price"
                          className="frg-input-field color-light"
                          style={{ width: '100%' }}
                          onChange={e => onChange(e, idx, 'price')}
                        />
                      </HorizontalContent>
                    </div>
                  </Td>
                )}
                <Td>
                  <input
                    type="Number"
                    onWheel={e => e.target.blur()}
                    value={quantity}
                    placeholder={quantity}
                    className="frg-input-field color-light"
                    style={{ width: '100%' }}
                    onChange={e => onChange(e, idx, 'quantity')}
                  />
                </Td>
              </Tr>
            );
          }
        )}
      </Table>

      {error && <Error text={error} />}
    </>
  );
};

Services.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number,
      id: PropTypes.number,
      isMandatory: PropTypes.boolean,
      name: PropTypes.string,
      price: PropTypes.number,
      productCategory: PropTypes.shape({
        name: PropTypes.string
      }),
      productDiscount: PropTypes.shape({
        oneYear: PropTypes.number,
        threeYear: PropTypes.number,
        fiveYear: PropTypes.number
      }),
      productSubcategory: PropTypes.shape({
        name: PropTypes.string
      }),
      quantity: PropTypes.number,
      subcategoryId: PropTypes.number
    })
  ).isRequired,
  onProductsChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.string
};

export default Services;
